import React from "react";

// Event-specific X/LinkedIn links, styled to match the profile social list
// in Hero.jsx — label + arrow, not icon buttons.
const SocialIconLinks = ({ socials, label }) => {
  if (!socials?.twitter && !socials?.linkedin) return null;

  return (
    <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2 border-t border-line pt-4">
      {socials.twitter && (
        <a
          href={socials.twitter}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${label} on X`}
          className="py-2 font-mono text-xs text-faint underline-offset-4 transition-colors duration-100 hover:text-fg hover:underline"
        >
          X ↗
        </a>
      )}
      {socials.linkedin && (
        <a
          href={socials.linkedin}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${label} on LinkedIn`}
          className="py-2 font-mono text-xs text-faint underline-offset-4 transition-colors duration-100 hover:text-fg hover:underline"
        >
          LinkedIn ↗
        </a>
      )}
    </div>
  );
};

export default SocialIconLinks;
